import type { LazyCreateFormConfig } from '@workwave-tidal/form-fairy'
import type { ValidationSummaryItem } from '@workwave-tidal/form-ui/utils/ValidationSummary'
import type { FormErrors, FormFields } from '../../../formFields'

import { useState } from 'react'
import { useSelector } from 'react-redux'

import { selectUsername } from '@/features/domain/user'
import { useStandardPasswordValidations } from '@/hooks'

import { useOldPasswordValidations } from './hooks/useOldPasswordValidations'

export function useCreateFormConfig(): {
  createFormConfig: LazyCreateFormConfig<FormFields, FormErrors>
  validationSummaryItems: ValidationSummaryItem<FormFields>[]
} {
  // Old password validations
  const oldPasswordValidations = useOldPasswordValidations<FormFields, FormErrors>()

  // the password being changed belongs to the logged in user
  const username = useSelector(selectUsername)

  // New Password validations
  const { validations: newPasswordvalidations, validationSummaryItems } =
    useStandardPasswordValidations<FormFields, FormErrors>('newPassword', { username })

  const [createFormConfig] = useState<LazyCreateFormConfig<FormFields, FormErrors>>(() => {
    return { validations: [...newPasswordvalidations, ...oldPasswordValidations] }
  })

  return { createFormConfig, validationSummaryItems }
}
